import React, { createContext, useContext, useState, useCallback } from 'react';
import { useMediaQuery } from '../hooks/useMediaQuery';

interface PdfViewerState {
  activeDocumentId: string | null;
  directPdfUrl: string | null;
  downloadFilename: string | null;
  isOpen: boolean;
  isPushModePdf: boolean;
  open: (documentId: string) => void;
  openUrl: (url: string, filename: string) => void;
  close: () => void;
}

const PdfViewerContext = createContext<PdfViewerState>({
  activeDocumentId: null,
  directPdfUrl: null,
  downloadFilename: null,
  isOpen: false,
  isPushModePdf: false,
  open: () => {},
  openUrl: () => {},
  close: () => {},
});

export const PdfViewerProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [activeDocumentId, setActiveDocumentId] = useState<string | null>(null)
  const [directPdfUrl, setDirectPdfUrl] = useState<string | null>(null)
  const [downloadFilename, setDownloadFilename] = useState<string | null>(null)
  const [isOpen, setIsOpen] = useState(false)
  const isWide = useMediaQuery('(min-width: 1200px)')
  const isPushModePdf = isOpen && isWide

  const open = useCallback((documentId: string) => {
    setDirectPdfUrl(null)
    setDownloadFilename(null)
    setActiveDocumentId(documentId)
    setIsOpen(true)
  }, [])

  const openUrl = useCallback((url: string, filename: string) => {
    setActiveDocumentId(null)
    setDirectPdfUrl(url)
    setDownloadFilename(filename)
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
    setActiveDocumentId(null)
    if (directPdfUrl) {
      URL.revokeObjectURL(directPdfUrl)
    }
    setDirectPdfUrl(null)
    setDownloadFilename(null)
  }, [directPdfUrl])

  return (
    <PdfViewerContext.Provider value={{activeDocumentId, directPdfUrl, downloadFilename, isOpen, isPushModePdf, open, openUrl, close}}>
      {children}
    </PdfViewerContext.Provider>
  )
}

export function usePdfViewer(): PdfViewerState {
  return useContext(PdfViewerContext)
}
